export enum AdditionalCertificationEnum {
    OPERATIONAL_ACCREDITATION = 'operationalAccreditation',
}

export enum AdditionalCertificationDict {
    'operationalAccreditation' = 'Acreditación de personal operativo',
}
